import React from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../components/Button";
import { convertEpochToDateDMY, getOrderDocuments } from "../../../../../utils";
import { useHistory } from "react-router-dom";
import BPADocumentsPreview from "../../../../../../../templates/ApplicationDetails/components/BPADocumentsPreview";

function RegistrationSummary() {
    const { handleSubmit, control, setValue, getValues, watch } = useForm();
    const { t } = useTranslation()
    const location = useLocation();
    const history = useHistory()
    const summaryData = location?.state;
    const businessService = summaryData?.businessService
    const applicationNumber = summaryData?.applicationNumber
    const stateId = Digit.ULBService.getStateId();
    let improvedDoc = [];
    summaryData?.tradeLicenseDetail?.applicationDocuments?.map(appDoc => { improvedDoc.push({ ...appDoc, module: "tl" }) });
    const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });
    
    let applicationDocs = []
    if (pdfDetails?.pdfFiles?.length > 0) {
        pdfDetails?.pdfFiles?.map(pdfAppDoc => {
            if (pdfAppDoc?.module == "tl") applicationDocs.push(pdfAppDoc);
        });
    }
    const onSubmit = (data) => {
        history.push(`/digit-ui/citizen/payment/collect/${businessService}/${applicationNumber}/${stateId}?tenantId=${stateId}`)
    }

    return (
        <section className="container1" style={{ marginTop: 0 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Applicant Type</h2>
                    </div>
                    <div className="formInputContainer">
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>{t('Application No')}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.applicationNumber || ''}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Applicant Type")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.additionalDetail?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Council for Architecture No.")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.additionalDetail?.tradeLicenseDetail?.additionalDetail?.counsilForArchNo || ''}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Registration Date")}</Grid>
                            <Grid item xs={6} md={3}><strong>{convertEpochToDateDMY(summaryData?.applicationDate)}</strong></Grid>
                        </Grid>
                    </div>
                </div>

                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Applicant Details</h2>
                    </div>
                    <div className="formInputContainer">
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>{t('Applicant Name')}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.name}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Applicant Mobile No")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.mobileNumber}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Gender")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.gender}</strong></Grid>
                            <Grid item xs={6} md={3}>{t('Applicant Email-Id')}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.emailId}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("College")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.college}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("University")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.university}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Year of Passing")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.passingYear}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("PanCard")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.pan}</strong></Grid>
                        </Grid>
                    </div>
                </div>

                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Address Details</h2>
                    </div>
                    <div className="formInputContainer">
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>{t('Correspondence Address')}</Grid>
                            <Grid item xs={6} md={3}></Grid>
                            <Grid item xs={6} md={3}>{t('Permanent Address')}</Grid>
                            <Grid item xs={6} md={3}></Grid>
                            <Grid item xs={6} md={3}>{t('Address')}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.address}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Address")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.address}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("State")}</Grid>
                            <Grid item xs={6} md={3}><strong>{'Uttar Pradesh'}</strong></Grid>
                            <Grid item xs={6} md={3}>{t('State')}</Grid>
                            <Grid item xs={6} md={3}><strong>{'Uttar Pradesh'}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("District")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.district}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("District")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.district}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Tehsil")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.tehsil}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Tehsil")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.tehsil}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Town/Village/Ward")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.town}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("Town/Village/Ward")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.town}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("PinCode")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.correspondenceAddress?.pinCode}</strong></Grid>
                            <Grid item xs={6} md={3}>{t("PinCode")}</Grid>
                            <Grid item xs={6} md={3}><strong>{summaryData?.tradeLicenseDetail?.owners?.[0]?.permanentAddress?.pinCode}</strong></Grid>
                        </Grid>
                    </div>
                </div>

                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Document Details</h2>
                    </div>
                    <div className="formInputContainer">
                        <Grid container spacing={2}>
                            <BPADocumentsPreview documents={getOrderDocuments(applicationDocs)} />
                        </Grid>
                    </div>
                </div>

                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Fee Details</h2>
                    </div>
                    <div className="formInputContainer">
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>{t('Total Amount')}</Grid>
                            <Grid item xs={6} md={3}>{summaryData?.calculation?.taxHeadEstimates?.[0]?.estimateAmount}</Grid>
                        </Grid>
                    </div>
                </div>

                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Make Payment"
                            type="submit"
                        />
                    </div>
                </div>
            </form>
        </section>
    )
}

export default RegistrationSummary